export default class Case {
  constructor() {
    this.id = "";
    this.name = "";
    this.description = "";
    this.barCode = "";
    this.rfid = "";
    this.status = 1;
  }
  update(data) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.barCode = data.barCode;
    this.rfid = data.rfid;
    this.status = data.status;
  }
}